<app-page-header
  >{{
    offers?.replacement_offers?.length > 1
      ? 'Product details'
      : 'Your replacement'
  }}
</app-page-header>

<div *ngIf="offers?.replacement_offers?.length === 1" class="header">
  <app-header-summary
    [currentItem]="offers?.current_item"
    [currentPlan]="offers?.current_plan"
    [offer]="offers?.offer"
    [upsellEnabled]="upsellEnabled$ | async"
  >
  </app-header-summary>
</div>
<div id="top">
  <div
    class="container container__product-details"
    *ngIf="selected?.article_id"
  >
    <div class="page-header">
      <a
        (click)="routeBack()"
        (keydown.enter)="routeBack()"
        (keydown.space)="routeBack(); $event.preventDefault()"
        tabindex="0"
        queryParamsHandling="merge"
        class="link typog-body-large-bold"
        ><i class="fa-solid fa-arrow-left mr-1"></i>Back</a
      >
      <div class="replacement--title">
        <h3>
          <span>{{ selected?.make }}</span>
          <span> {{ selected?.appliance_category }}</span>
        </h3>
        <h5 class="mt-1">{{ selected?.model }}</h5>
      </div>
    </div>

    <div class="grid-row">
      <div class="xs-12 lg-6 replacement">
        <div class="xs--stack">
          <app-carousel
            [slides]="selected?.images"
            (clicked)="onThumbnailClicked()"
          >
          </app-carousel>
        </div>
      </div>

      <div class="xs-12 lg-6">
        <div class="xs--stack">
          <div
            class="upgrade-price flex align--center"
            *ngIf="selected.upgrade_fee"
          >
            <dgx-components-icon
              [name]="'sparkles'"
              [size]="'md'"
              class="mr-2"
            ></dgx-components-icon>
            <p>Upgrade to this model</p>
            <div class="upgrade-price__value text--center">
              <h5
                class="d-block"
                [class.upgrade-price__value--cost]="selected?.upgrade_fee > 0"
              >
                {{ selected?.upgrade_fee | currency : 'GBP' }}
              </h5>
              <small class="d-block">One-off fee</small>
            </div>
          </div>

          <app-panel
            class="overview has-summary-specs"
            *ngIf="selected?.summary_specs?.length"
          >
            <div class="container__overview">
              <h5 class="header">Product overview</h5>
              <app-overview-list-container [offer]="selected">
              </app-overview-list-container>

              <div
                class="delivery-notice"
                *ngIf="getDelivery$ | async as delivery"
              >
                <div
                  class="wrapper flex align--center"
                  [class.accept]="
                    (productDetailsService.deliveryDatesLoading$ | async) ===
                      false &&
                    (productDetailsService.deliveryDatesError$ | async) ===
                      false
                  "
                >
                  <div>
                    <span
                      class="icon icon-unavailable icon--lg"
                      *ngIf="
                        (productDetailsService.deliveryDatesLoading$ | async) ||
                          (productDetailsService.deliveryDatesError$ | async);
                        else available
                      "
                    ></span>
                  </div>

                  <div class="availability ml-2 mr-2">
                    <i class="fa-regular fa-truck"></i>
                    <app-simple-loader
                      *ngIf="
                        productDetailsService.deliveryDatesLoading$ | async;
                        else loaded
                      "
                    >
                    </app-simple-loader>
                    <ng-template #loaded>
                      <strong [@fadeInOut] class="text">{{
                        delivery?.price_gross && delivery?.charge_customer
                          ? (delivery?.price_gross | currency : 'GBP') +
                            ' delivery'
                          : 'Free delivery'
                      }}</strong>
                      <span
                        *ngIf="
                          deliveryDates$
                            | async
                            | earliestDeliveryDateText as deliveryText
                        "
                        >{{ deliveryText }}
                      </span>
                    </ng-template>
                  </div>
                </div>
              </div>

              <a
                class="link link--primary nav-spec-header has-summary-specs typog-body-large-bold mt-5"
                (click)="navSpecHeaderClick()"
                >Show full specifications</a
              >
            </div>
          </app-panel>

          <app-panel
            class="delivery"
            *ngIf="!selected?.summary_specs?.length"
            [class.has-summary-specs]="selected?.summary_specs?.length"
          >
            <div class="container__delivery">
              <h5 class="header">Your delivery</h5>
              <div class="container" *ngIf="getDelivery$ | async as delivery">
                <div
                  class="wrapper flex align--center"
                  [class.accept]="
                    (productDetailsService.deliveryDatesLoading$ | async) ===
                      false &&
                    (productDetailsService.deliveryDatesError$ | async) ===
                      false
                  "
                >
                  <div>
                    <span
                      class="icon icon-unavailable icon--lg"
                      *ngIf="
                        (productDetailsService.deliveryDatesLoading$ | async) ||
                          (productDetailsService.deliveryDatesError$ | async);
                        else available
                      "
                    ></span>
                  </div>

                  <div class="availability ml-2 mr-2">
                    <i class="fa-regular fa-truck"></i>
                    <app-simple-loader
                      *ngIf="
                        productDetailsService.deliveryDatesLoading$ | async;
                        else loaded
                      "
                    >
                    </app-simple-loader>
                    <ng-template #loaded>
                      <strong [@fadeInOut] class="text">{{
                        delivery?.price_gross && delivery?.charge_customer
                          ? (delivery?.price_gross | currency : 'GBP') +
                            ' delivery'
                          : 'Free delivery'
                      }}</strong>
                      <span
                        *ngIf="
                          deliveryDates$
                            | async
                            | earliestDeliveryDateText as deliveryText
                        "
                      >
                        {{ deliveryText }}
                      </span>
                    </ng-template>
                  </div>
                </div>
              </div>

              <div
                class="container"
                *ngIf="(isDeliveryServiceAvailable$ | async) !== true"
              >
                <div class="wrapper">
                  <div class="availability">
                    <i class="fa-regular fa-truck"></i>
                    <strong [@fadeInOut] class="text"
                      >Delivery is not available for this product</strong
                    >
                  </div>
                </div>
              </div>
            </div>
          </app-panel>

          <app-panel *ngIf="compareSpec?.hasDifference" class="spec-difference">
            <h5 class="header">Check before ordering</h5>
            <div class="header-summary text--center">
              <div class="spec-difference__summary text--left">
                <i class="fa-regular fa-exclamation-circle"></i>
                <p>
                  This model has some important differences from your old one –
                  please check it’s right for you.
                </p>
              </div>
            </div>
            <div class="spec-table-data">
              <table>
                <tbody>
                  <tr class="r-table__row">
                    <th>Differences</th>
                    <th>Your product</th>
                    <th>This model</th>
                  </tr>
                  <tr
                    class="r-table__row"
                    *ngFor="let spec of compareSpec.current; index as i"
                  >
                    <th class="r-table__heading">
                      {{ spec?.name }}
                    </th>
                    <td class="r-table__cell">
                      {{ compareSpec.current[i]?.value }}
                    </td>
                    <td class="r-table__cell">
                      {{ compareSpec.selected[i]?.value }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <dgx-components-button
              class="mt-6"
              variant="primary"
              (click)="continueClick()"
              [fill]="true"
              [disabled]="
                (isDeliveryServiceAvailable$ | async) !== true ||
                (productDetailsService.deliveryDatesLoading$ | async) ||
                (productDetailsService.deliveryDatesError$ | async)
              "
              >I want this</dgx-components-button
            >
          </app-panel>

          <app-panel class="overview" *ngIf="!compareSpec?.hasDifference">
            <div class="container__overview">
              <h5 class="header">Ready to order?</h5>
              <dgx-components-button
                variant="primary"
                (click)="continueClick()"
                [fill]="true"
                [disabled]="
                  (isDeliveryServiceAvailable$ | async) !== true ||
                  (productDetailsService.deliveryDatesLoading$ | async) ||
                  (productDetailsService.deliveryDatesError$ | async)
                "
                >I want this</dgx-components-button
              >
            </div>
          </app-panel>
        </div>
      </div>
    </div>

    <div
      class="xs-12--none md-12--none"
      [class.pb-20]="offers?.replacement_offers?.length === 1"
    >
      <div class="xs--stack">
        <div class="container__specifications xs-row">
          <app-expandable-spec-table
            *ngIf="selected?.detailed_specs?.length"
            [specifications]="selected?.detailed_specs"
            [keyFeatures]="selected?.key_features"
          >
          </app-expandable-spec-table>
        </div>

        <app-cta
          class="compare-cta"
          kind="compare-card"
          [hasCheckbox]="true"
          [isChecked]="selected | isChecked : comparisonsSelected"
          [disabled]="
            limitReached && !(selected | isChecked : comparisonsSelected)
          "
          (clicked)="onComparisonClick(selected)"
        >
          Compare my product
        </app-cta>
      </div>
    </div>
  </div>
</div>
<app-another-look-container
  *ngIf="offers?.replacement_offers?.length > 1"
  [replacementOffers]="filteredAnotherLookOffers$ | async"
  (cardClicked)="onCardClick($event)"
  (comparisonClicked)="onComparisonClick($event)"
  [rrpFlag]="offers?.offer?.rrp_flag"
>
</app-another-look-container>

<app-compare-container
  *ngIf="offers?.replacement_offers?.length && (comparisons$ | async)?.length"
  [@slideInOut]
  class="sticky-element"
  [comparisonsSelected]="comparisons$ | async"
  [currentItem]="offers?.current_item"
  (mediumComparisonRemoved)="onComparisonClick($event)"
  (largeComparisonRemoved)="onComparisonClick($event)"
  (comparisonSelected)="onComparisonSelectedClick($event)"
  (compareClicked)="onCompareClicked()"
>
</app-compare-container>

<app-delivery-unavailable-modal
  *ngIf="
    offers?.replacement_offers?.length >= 1 &&
    ((productDetailsService.deliveryDatesError$ | async) ||
      (getDelivery$ | async) === null)
  "
  [numberOfReplacementOffers]="offers?.replacement_offers?.length"
  [isDeliveryDatesApiError]="isDeliveryDatesApiError$ | async"
  [@fadeInOut]
>
</app-delivery-unavailable-modal>
